'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import { memoize } from '../../utils/functions';
import { jsx as _jsx } from "react/jsx-runtime";
const MENU_SPLIT_RATIO = 2 / 3;
const MENU_SPLIT_BUFFER = 12;
// For controls starting in the more menu since they haven't been rendered yet
const DEFAULT_CONTROL_RECT = {
  width: 24,
  marginLeft: 4
};
export default class MoreMenuContent extends Component {
  constructor(props) {
    super(props);
    this.getMenu = () => {
      const {
        toolbarWidth,
        menuItems
      } = this.props;
      const menuControlWidths = this.getMenuControlWidths();
      return menuControlWidths > toolbarWidth * MENU_SPLIT_RATIO ? this.splitMenus(menuItems, menuControlWidths) : [menuItems];
    };
    this.getControlWidth = control => {
      const {
        width,
        marginLeft
      } = this.props.controlRects[control] || DEFAULT_CONTROL_RECT;
      return width + marginLeft;
    };
    this.getMenuControlWidths = () => {
      return this.props.menuItems.reduce((acc, {
        name
      }) => acc + this.getControlWidth(name), 0);
    };
    this.splitMenus = (menuItems, menuControlWidths) => {
      let splitIndex = 0;
      let splitValue = 0;
      while (splitValue <= menuControlWidths / 2 - MENU_SPLIT_BUFFER) {
        splitValue += this.getControlWidth(menuItems[splitIndex].name);
        splitIndex++;
      }
      if (splitIndex === 0 || splitIndex === menuItems.length) {
        return [menuItems];
      }
      return [menuItems.slice(0, splitIndex), menuItems.slice(splitIndex)];
    };
    this.renderControl = ({
      name,
      renderControl
    }, itemIndex) => {
      const {
        contextualNodeAttributes
      } = this.props;
      return /*#__PURE__*/_jsx("div", {
        className: itemIndex > 0 ? 'm-left-1' : '',
        children: renderControl({
          contextualNodeAttributes
        })
      }, `more-${name}`);
    };
    this.renderMenuRow = (row, index) => {
      return /*#__PURE__*/_jsx(UIFlex, {
        className: index > 0 ? 'm-top-2' : '',
        align: "center",
        children: row.map(this.renderControl)
      }, `menu-row-${index}`);
    };
    this.splitMenus = memoize(this.splitMenus.bind(this), menuItems => menuItems.length);
  }
  render() {
    const menu = this.getMenu();
    return /*#__PURE__*/_jsx("div", {
      ref: node => this.node = node,
      className: "p-all-2",
      children: menu.map(this.renderMenuRow)
    });
  }
}
MoreMenuContent.propTypes = {
  menuItems: PropTypes.array.isRequired,
  toolbarWidth: PropTypes.number.isRequired,
  controlRects: PropTypes.object.isRequired,
  contextualNodeAttributes: PropTypes.object
};